import type { Components, CSSObject, Theme } from '@mui/material';

export const MuiTabs: Components<Theme>['MuiTabs'] = {
  styleOverrides: {
    root: ({ theme }): CSSObject => ({
      width: 'auto',
      display: 'flex',
      alignItems: 'center',
      '& .MuiTabs-indicator': {
        display: 'none',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    }),
  },
};
